import { message } from "antd";
import { client } from "../../../../actions";
import { authHeader } from "../../../../helpers/auth-header";
import actions from "../actions/actions";

const getAddressMeters =
	(houseId, meterTypes, meterCode, activeTags) => async (dispatch) => {
		try {
			dispatch({
				type: actions.ITEM_LOADING,
			});
			const response = await client.get(
				`/Meter/meters_for_address?${
					meterTypes?.length > 0 ? `meterType=${meterTypes?.join(",")}` : ""
				}${activeTags?.length > 0 ? `&tagIds=${activeTags?.join(",")}` : ""}`,
				{
					headers: authHeader(),
					params: {
						houseId,
						meterCode,
					},
				}
			);
			dispatch({
				type: actions.METERS_LOADED,
				payload: response.data,
			});
		} catch (e) {
			console.log(e);
			message.error("При загрузке счётчиков произошла ошибка");
		}
	};

export default getAddressMeters;
